"use strict";

module.exports = function () {
  return this.$scopedSlots["default"]({
    source: this.source,
    theme: this.theme,
    opts: this.opts,
    perPageValues: this.perPageValues,
    totalPages: this.totalPages,
    slots: this.$parent.$slots,
    override: this.componentsOverride.dataTable
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/components/renderless/RLDataTable.js
// module id = BJTV
// module chunks = 0